import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import {
  bookingTypeEnumToTranslatedText,
  constructCalendarHighlights,
  convertJSDateToDotNetDateTimeDayEnd,
  convertJSDateToDotNetDateTimeDayStart,
  convertJSDateToDotNetDateTimeWithTime,
  differenceBetweenDatesAsDaysInteger,
  formattedAmountWithEuroCurrency,
} from "../../common/misc";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  AddBookingOwnerNote,
  BookingItem,
  BookingsRequest,
  getAccommodationsBookingsAsync,
  getBookingDetailsAsync,
  OwnerOwnBooking,
  OwnerOwnBookingNote,
  saveOwnerOwnBookingAsync,
  selectAccommodationsBookingItems,
  selectBookingItemsLoadingStatus,
} from "./bookingsSlice";
import {
  AvailableAccommodationsFilter,
  getAvailableAccommodationsAsync,
  selectAccommodationsLoadingStatus,
  selectAvailableAccommodationItems,
  selectAvailableAccommodationsLoadingStatus,
} from "../AccommodationsPage/accommodationsSlice";
import { LOADING_STATUS } from "../../common/constants";
import { useAuthUser } from "../../features/auth/authHooks";
import ReactDayPickerWrapper from "../../components/DayPicker/ReactDayPickerWrapper";
import ReactDatePicker from "react-datepicker";
import { DateRange } from "react-day-picker";
import { addStatusToast } from "../../components/StatusToast";
import { clearInputErrors } from "../../features/errors/errorsSlice";
import LocalizedDatePicker from "../../components/DatePicker/LocalizedDatePicker";

interface BookingModalWrapperProps {
  accommodationId: string;
  accommodationName: string;
  accommodationNumber: string;
  selectedDateRange: DateRange;
  showModal: boolean;
  setParentShowBookingModal: Function;
  callParentInitFetch: Function;
}
const BookingModalWrapper: React.FC<BookingModalWrapperProps> = ({
  accommodationId = "",
  accommodationName = "",
  accommodationNumber = "",
  selectedDateRange,
  showModal,
  setParentShowBookingModal,
  callParentInitFetch,
}) => {
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  //const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setParentShowBookingModal(false);
  const availableAccommodations = useAppSelector(
    selectAvailableAccommodationItems,
  );
  const availableAccommodationsLoadingStatus = useAppSelector(
    selectAvailableAccommodationsLoadingStatus,
  );
  const [ownerOwnBookingNote, setOwnerOwnBookingNote] = useState("");
  const [savingOwnerBooking, setSavingOwnerBooking] = useState(false);
  const [ownerOwnBookingAdults, setOwnerOwnBookingAdults] = useState(1);
  const [ownerOwnBookingChildren, setOwnerOwnBookingChildren] = useState(0);
  const [ownerOwnBookingType, setOwnerOwnBookingType] = useState("OwnerOwn");
  const [linenChecked, setLinenChecked] = useState(false);
  const [cleaningChecked, setCleaningChecked] = useState(false);
  const resetOwnerOwnBookingForm = useCallback(() => {
    setOwnerOwnBookingNote("");
    setOwnerOwnBookingAdults(1);
    setOwnerOwnBookingChildren(0);
    setOwnerOwnBookingType("OwnerOwn");
    setLinenChecked(false);
    setCleaningChecked(false);
  }, []);

  useEffect(() => {
    if (showModal) {
      resetOwnerOwnBookingForm();
    }
  }, [showModal, resetOwnerOwnBookingForm]);
  useEffect(() => {
    if (accommodationId != null && selectedDateRange != null) {
      let availableAccommodationsFilter: AvailableAccommodationsFilter =
        new (class implements AvailableAccommodationsFilter {
          accommodationId: string;
          endDate: string;
          startDate: string;
        })();
      availableAccommodationsFilter.startDate =
        convertJSDateToDotNetDateTimeWithTime(selectedDateRange.from);
      availableAccommodationsFilter.endDate =
        convertJSDateToDotNetDateTimeWithTime(selectedDateRange.to);
      availableAccommodationsFilter.accommodationId = accommodationId;
      dispatch(getAvailableAccommodationsAsync(availableAccommodationsFilter));
    }
  }, [accommodationId, selectedDateRange]);

  const saveOwnerOwnBooking = () => {
    setSavingOwnerBooking(true);
    let ownerOwnBooking: OwnerOwnBooking = new (class
      implements OwnerOwnBooking
    {
      ownerId: string;
      AccommodationId: string;
      ArrivalDateTime: string;
      DepartureDateTime: string;
      OwnerBookingNote: OwnerOwnBookingNote;
      Adults: number;
      Childs: number;
      BookingType: string;
    })();
    //Handle arrival and departure time
    selectedDateRange.from.setHours(16);
    selectedDateRange.from.setMinutes(0);
    selectedDateRange.from.setSeconds(0);
    selectedDateRange.to.setHours(12);
    selectedDateRange.to.setMinutes(0);
    selectedDateRange.to.setSeconds(0);
    ownerOwnBooking.ownerId = ownerAccountId;
    ownerOwnBooking.AccommodationId = accommodationId;
    ownerOwnBooking.ArrivalDateTime = convertJSDateToDotNetDateTimeWithTime(
      selectedDateRange.from,
    );
    ownerOwnBooking.DepartureDateTime = convertJSDateToDotNetDateTimeWithTime(
      selectedDateRange.to,
    );
    ownerOwnBooking.OwnerBookingNote = new (class
      implements OwnerOwnBookingNote
    {
      NoteText: string;
    })();
    let numberOfPeopleInBooking =
      ownerOwnBookingAdults + ownerOwnBookingChildren;
    ownerOwnBooking.OwnerBookingNote.NoteText = "";
    if (linenChecked) {
      ownerOwnBooking.OwnerBookingNote.NoteText +=
        "Sisältää liinavaatteet " + numberOfPeopleInBooking + " kpl\n";
    }
    if (cleaningChecked) {
      ownerOwnBooking.OwnerBookingNote.NoteText += "Sisältää loppusiivouksen\n";
    }
    ownerOwnBooking.OwnerBookingNote.NoteText += ownerOwnBookingNote;
    ownerOwnBooking.Adults = ownerOwnBookingAdults;
    ownerOwnBooking.Childs = ownerOwnBookingChildren;
    ownerOwnBooking.BookingType = ownerOwnBookingType;
    //callParentInitFetch();
    //handleModalClose();

    dispatch(saveOwnerOwnBookingAsync(ownerOwnBooking)).then((res) => {
      setSavingOwnerBooking(false);
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          addStatusToast({
            Message: `Omistajan oma varaus tallennettu!`,
          }),
        );
        if (callParentInitFetch != null) {
          callParentInitFetch();
        }
        handleModalClose();
      }
    });
  };
  if (selectedDateRange == null) {
    return <></>;
  }
  if (availableAccommodationsLoadingStatus != LOADING_STATUS.IDLE) {
    return (
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Varaus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div>
              Tarkistetaan kohteen saatavuus...
              <Spinner animation="border" />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
  if (availableAccommodations.length == 0) {
    return (
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Varaus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <>Kohde ei ole enää satavilla</>;
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
  let availableAccommodation = availableAccommodations[0];

  return (
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Varaus</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="d-grid gap-16">
            <Form.Group>
              <Form.Label>Kohde</Form.Label>
              {availableAccommodation.accommodationNumber != "" && (
                <p className="mb-0">
                  {availableAccommodation.accommodationNumber},{" "}
                  {availableAccommodation.name},{" "}
                  {formattedAmountWithEuroCurrency(
                    availableAccommodation.price,
                  )}
                </p>
              )}
              {availableAccommodation.accommodationNumber == "" && (
                <p className="mb-0">
                  {availableAccommodation.name},{" "}
                  {formattedAmountWithEuroCurrency(
                    availableAccommodation.price,
                  )}
                </p>
              )}
            </Form.Group>

            <div className="d-flex  gap-8 align-items-center">
              <div className="w-100 position-relative">
                <Form.Label>Tulo</Form.Label>
                <LocalizedDatePicker
                  onChange={(date) => console.log(date)}
                  selectsStart
                  selected={selectedDateRange.from}
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  disabled={true}
                  showWeekNumbers
                />
                <Button
                  variant="link"
                  className="pe-none position-absolute end-0 bottom-0"
                  id="button-addon2"
                >
                  <span className="bi bi-calendar2-event"></span>
                </Button>
              </div>

              <div className="w-100 position-relative">
                <Form.Label>Lähtö</Form.Label>
                <LocalizedDatePicker
                  onChange={(date) => console.log(date)}
                  selectsEnd
                  className="form-control"
                  selected={selectedDateRange.to}
                  dateFormat="dd.MM.yyyy"
                  disabled={true}
                  showWeekNumbers
                />
                <Button
                  variant="link"
                  className="pe-none position-absolute end-0 bottom-0"
                  id="button-addon2"
                >
                  <span className="bi bi-calendar2-event"></span>
                </Button>
              </div>
            </div>
            <Form.Group>
              <Form.Select
                value={ownerOwnBookingType}
                onChange={(e) => setOwnerOwnBookingType(e.target.value)}
              >
                <option value="OwnerOwn">Oma varaus</option>
                <option value="TemporaryDisabled">
                  Väliaikainen myynnistä poisto
                </option>
                {/*<option value="Maintenance">Huoltokäynti</option>*/}
              </Form.Select>
            </Form.Group>

            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Aikuisia</Form.Label>
                  <Form.Select
                    value={ownerOwnBookingAdults}
                    onChange={(e) => setOwnerOwnBookingAdults(+e.target.value)}
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Lapsia</Form.Label>
                  <Form.Select
                    value={ownerOwnBookingChildren}
                    onChange={(e) =>
                      setOwnerOwnBookingChildren(+e.target.value)
                    }
                  >
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group>
              <Form.Label>Palvelut</Form.Label>
              <Form.Check
                label="Loppusiivous"
                className="mb-8"
                id="finalcleaning"
                checked={cleaningChecked}
                onChange={(e) => setCleaningChecked(e.target.checked)}
              />
              <Form.Check
                label="Liinavaatteet"
                checked={linenChecked}
                onChange={(e) => setLinenChecked(e.target.checked)}
                id="lining"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Lisätiedot</Form.Label>
              <Form.Control
                as="textarea"
                value={ownerOwnBookingNote}
                onChange={(e) => setOwnerOwnBookingNote(e.target.value)}
                rows={3}
              />
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {savingOwnerBooking && (
          <>
            <Spinner animation="border" />
            Varausta luodaan...
          </>
        )}
        {!savingOwnerBooking && (
          <>
            <Button variant="outline-blue" onClick={handleModalClose}>
              Peruuta
            </Button>
            <Button variant="primary" onClick={saveOwnerOwnBooking}>
              Vahvista varaus
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default BookingModalWrapper;
